import AssetsUnderAdviceGrid from "../../features/assetsunderadvicegrid";
import { AssetViewTypes } from "../../features/assetsunderadvicegrid/hooks/AssetsUnderAdviceContext";

const ClientsSummaryPage = () => (
    <section className="px-4 my-3 h-100">
        <AssetsUnderAdviceGrid viewType={AssetViewTypes.ClientsSummary} />
    </section>
)

export default ClientsSummaryPage;